import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const ValidIncidentsPerVulnerability
 = () => {

    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="VULNERABILITYTYPEVICTIM" disaggregation = "sex"/>
        </>
    
  )
}

export default ValidIncidentsPerVulnerability
